import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccordionConfig } from 'ngx-bootstrap/accordion';
import { ApilistService } from 'src/app/services/apilist.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { AuthorisedSideNavService } from '../services/authorised-side-nav.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export function getAccordionConfig(): AccordionConfig {
  return Object.assign(new AccordionConfig(), { closeOthers: true });
}

@Component({
  selector: 'app-authorised-side-nav',
  standalone: true,
  imports: [
    CommonModule, // for *ngIf, *ngFor, ngStyle
    FormsModule, // for [(ngModel)]
    ReactiveFormsModule, // for reactive forms if needed
  ],
  templateUrl: './authorised-side-nav.component.html',
  styleUrls: ['./authorised-side-nav.component.scss'],
  providers: [{ provide: AccordionConfig, useFactory: getAccordionConfig }],
  animations: [
    trigger('toggleBox', [
      state(
        'open',
        style({
          height: 'auto',
          backgroundColor: 'transparent',
        })
      ),
      state(
        'closed',
        style({
          height: '0px',
          backgroundColor: 'transparent',
        })
      ),
      transition('open => closed', [animate('0.3s')]),
      transition('closed => open', [animate('0.3s')]),
    ]),
  ],
})
export class AuthorisedSideNavComponent implements OnInit {
  // ===== existing state & flags =====
  public isCollapsed: boolean = false;
  public display = 'none';
  showError: boolean = false;
  ErrorMsg: string;
  isContentOpen: boolean = false;
  toggle = {};
  getId: any;
  sideMenu_list: any;
  exit: boolean;

  isOpen = false;
  isCollegeOpen = false;
  isMaterialOpen = false;

  screenWidth: number = window.screen.width;

  showNormal = true;
  showWhite = false;

  showWhiteClg = false;
  showNormalClg = true;

  showWhiteAC = false;
  showNormalAC = true;

  showWhiteClgCourse = false;
  showNormalClgCourse = true;

  showWhiteClgVideo = false;
  showNormalClgVideo = true;

  showWhiteClgImage = false;
  showNormalClgImage = true;

  showWhiteCourse = false;
  showNormalCourse = true;

  showWhiteAdCourse = false;
  showNormalAdCourse = true;

  showWhiteDegreetype = false;
  showNormalDegreetype = true;

  showWhiteCoursetype = false;
  showNormalCoursetype = true;

  showWhiteDegree = false;
  showNormalDegree = true;

  showWhiteScope = false;
  showNormalScope = true;

  showWhiteCountry = false;
  showNormalCountry = true;

  showWhiteAdimage = false;
  showNormalAdimage = true;

  showWhiteuser = false;
  showNormaluser = true;

  showWhiteadmin = false;
  showNormaladmin = true;

  showWhitelogout = false;
  showNormallogout = true;

  showWhiteCourseDetails = false;
  showNormalCourseDetails = true;

  // === NEW: Order College flags ===
  @ViewChild('boxOrderClg', { static: false }) boxOrderClg: ElementRef;
  showWhiteOrderClg = false;
  showNormalOrderClg = true;

  // existing ViewChild references
  @ViewChild('box', { static: false }) box: ElementRef;
  @ViewChild('boxClg', { static: false }) boxClg: ElementRef;
  @ViewChild('boxAdClg', { static: false }) boxAdClg: ElementRef;
  @ViewChild('boxClgCourse', { static: false }) boxClgCourse: ElementRef;
  @ViewChild('boxClgVideo', { static: false }) boxClgVideo: ElementRef;
  @ViewChild('boxClgImage', { static: false }) boxClgImage: ElementRef;
  @ViewChild('boxCourses', { static: false }) boxCourses: ElementRef;
  @ViewChild('boxScope', { static: false }) boxScope: ElementRef;
  @ViewChild('boxCountry', { static: false }) boxCountry: ElementRef;
  @ViewChild('boximage', { static: false }) boximage: ElementRef;
  @ViewChild('boxuser', { static: false }) boxuser: ElementRef;
  @ViewChild('boxadmin', { static: false }) boxadmin: ElementRef;
  @ViewChild('boxlogout', { static: false }) boxlogout: ElementRef;

  // ===== sidebar tracking & timing =====
  sidebarOpen: boolean = true;
  private readonly _sidebarTransitionMs = 300; // Adjust to match your CSS transition

  constructor(
    public sideNavService: AuthorisedSideNavService,
    public commonservice: CommonService,
    public utils: ApilistService,
    public router: Router,
    private modalService: NgbModal,
    private authservice: AuthService,
    public ngzone: NgZone,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    // keep original logic for responsive start state
    if (this.screenWidth <= 414) {
      let myTag;
      myTag = this.elementRef.nativeElement.querySelector('.page-wrapper');
      this.renderer.removeClass(myTag, 'toggled');
    } else {
      let myTag;
      myTag = this.elementRef.nativeElement.querySelector('.page-wrapper');
      this.renderer.addClass(myTag, 'toggled');
    }

    // existing vendor-subscription check
    if (localStorage.getItem('login-type') == '"vendor"') {
      let servicePath = this.utils.getApiConfigs('get_subscription');
      this.commonservice
        .invokeService(servicePath[0].method, servicePath[0].path, '')
        .then((respVal: any) => {
          if (respVal.payload.status == 200) {
            if (
              respVal.status.status != 'active' &&
              respVal.status.status != 'created'
            ) {
              this.display = 'block';
              this.exit = false;
            }
          }
        });
    }

    // ===== NEW: initialize sidebarOpen from DOM and emit initial event =====
    const wrapper =
      this.elementRef.nativeElement.querySelector('.page-wrapper');
    this.sidebarOpen = wrapper ? wrapper.classList.contains('toggled') : true;

    // set CSS var for initial layout
    this.setSidebarCssVar(this.sidebarOpen);

    // dispatch initial event after a tick so other components can subscribe in time
    setTimeout(() => {
      this.emitSidebarToggled(this.sidebarOpen);
    }, 0);
  }

  // ================= existing methods (logout etc.) =================
  logout() {
    this.display = 'block';
    this.exit = true;
  }

  /**
   * Toggle the left sidebar. This updates DOM classes (existing behavior),
   * updates the CSS variable for layout width and emits a `sidebarToggled`
   * CustomEvent after the CSS transition finishes so other components can react.
   */
  toggleNav() {
    const wrapperEl: HTMLElement | null =
      document.querySelector('.page-wrapper');

    // Toggle DOM class as before (keep compatibility with existing styles)
    if (wrapperEl) {
      // toggle the 'toggled' class on wrapper
      if (wrapperEl.classList.contains('toggled')) {
        this.renderer.removeClass(wrapperEl, 'toggled');
      } else {
        this.renderer.addClass(wrapperEl, 'toggled');
      }
    }

    // Keep body sidebar-collapsed behavior for legacy CSS
    if (document.body.classList.contains('sidebar-collapsed')) {
      document.body.classList.remove('sidebar-collapsed');
    } else {
      document.body.classList.add('sidebar-collapsed');
    }

    // Update sidebarOpen state based on wrapper class (safe sync)
    const wrapper =
      this.elementRef.nativeElement.querySelector('.page-wrapper');
    this.sidebarOpen = wrapper
      ? wrapper.classList.contains('toggled')
      : !this.sidebarOpen;

    // update CSS variable used by layout to reflow content automatically
    this.setSidebarCssVar(this.sidebarOpen);

    // emit the custom event after transition time so layout is finished
    setTimeout(
      () => this.emitSidebarToggled(this.sidebarOpen),
      this._sidebarTransitionMs + 20
    );

    // preserve existing code adjusting showTour / screenWidth
    let myTag;
    myTag = this.elementRef.nativeElement.querySelector('.page-wrapper');

    // ensure toggled class exists or not consistently
    if (this.sidebarOpen) {
      this.renderer.addClass(myTag, 'toggled');
    } else {
      this.renderer.removeClass(myTag, 'toggled');
    }

    this.screenWidth = window.screen.width;
    if (this.screenWidth <= 910 || this.screenWidth <= 1366) {
      this.commonservice.showTour = {
        'margin-left': '0px',
        transition: 'all .60s ease',
      };
    }
  }

  // ===== existing foreign uni toggle & handler code (unchanged) =====
  // State for showing submenu
  isForeignUniOpen = false;

  // State for icon color changes (Foreign Uni)
  showWhiteForeignUni = false;
  showNormalForeignUni = true;

  showWhiteForeignCourses = false;
  showNormalForeignCourses = true;

  showWhiteForeignColleges = false;
  showNormalForeignColleges = true;

  // Toggle submenu open/close
  toggleForeignUni() {
    this.isForeignUniOpen = !this.isForeignUniOpen;
  }

  // Hover handlers for Foreign Universities main item
  mouseOverForeignUni(event: any) {
    this.showWhiteForeignUni = true;
    this.showNormalForeignUni = false;
  }

  mouseOutForeignUni(event: any) {
    this.showWhiteForeignUni = false;
    this.showNormalForeignUni = true;
  }

  // Hover handlers for Add Courses
  mouseOverForeignCourses(event: any) {
    this.showWhiteForeignCourses = true;
    this.showNormalForeignCourses = false;
  }

  mouseOutForeignCourses(event: any) {
    this.showWhiteForeignCourses = false;
    this.showNormalForeignCourses = true;
  }

  // Hover handlers for Add Colleges
  mouseOverForeignColleges(event: any) {
    this.showWhiteForeignColleges = true;
    this.showNormalForeignColleges = false;
  }

  mouseOutForeignColleges(event: any) {
    this.showWhiteForeignColleges = false;
    this.showNormalForeignColleges = true;
  }
  // inside AuthorisedSideNavComponent class ...

  // toggleNav(): (replace existing method with this)
  // toggleNav() {
  //   const wrapperEl: HTMLElement | null = document.querySelector('.page-wrapper');

  //   if (wrapperEl) {
  //     if (wrapperEl.classList.contains('toggled')) {
  //       this.renderer.removeClass(wrapperEl, 'toggled');
  //     } else {
  //       this.renderer.addClass(wrapperEl, 'toggled');
  //     }
  //   }

  //   // keep body sidebar-collapsed behavior for legacy CSS
  //   if (document.body.classList.contains('sidebar-collapsed')) {
  //     document.body.classList.remove('sidebar-collapsed');
  //   } else {
  //     document.body.classList.add('sidebar-collapsed');
  //   }

  //   // update sidebarOpen and css var
  //   const wrapper = document.querySelector('.page-wrapper');
  //   this.sidebarOpen = wrapper ? wrapper.classList.contains('toggled') : !this.sidebarOpen;

  //   this.setSidebarCssVar(this.sidebarOpen);

  //   // emit event after transition (give a little extra time)
  //   setTimeout(() => this.emitSidebarToggled(this.sidebarOpen), this._sidebarTransitionMs + 20);

  //   // update commonservice.showTour if necessary (keep original behavior)
  //   this.screenWidth = window.screen.width;
  //   if (this.screenWidth <= 1366) {
  //     this.commonservice.showTour = { 'margin-left': '0px', transition: 'all .60s ease' };
  //   }
  // }

  // // closeNav(): ensure pages get notified as well
  // closeNav() {
  //   const wrapper = document.querySelector('.page-wrapper');
  //   if (wrapper && wrapper.classList.contains('toggled')) {
  //     this.renderer.removeClass(wrapper, 'toggled');
  //   }

  //   // set css var and emit the change so content pages can resize grid
  //   this.setSidebarCssVar(false);
  //   this.emitSidebarToggled(false);

  //   // hide backdrop
  //   const backdrop = document.querySelector('.backdrop') as HTMLElement | null;
  //   if (backdrop) {
  //     backdrop.style.display = 'none';
  //   }

  //   this.display = 'none';
  // }

  // Click handlers for Foreign Uni items
  addForeignCourses() {
    this.router.navigate(['/foreign-courses']);
  }

  addForeignColleges() {
    this.router.navigate(['/foreign-university']);
  }

  // ================= existing hover helpers & navigation =================
  onMouseOver(e) {
    this.showWhite = true;
    this.showNormal = false;
    (<HTMLDivElement>this.box.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.box.nativeElement).style.cursor = 'pointer';
  }

  onMouseOut(e) {
    this.showWhite = false;
    this.showNormal = true;
  }

  dashboard() {
    this.router.navigate(['/dashboard']);
  }

  mouseOverClg(e) {
    this.showWhiteClg = true;
    this.showNormalClg = false;
    (<HTMLDivElement>this.boxClg.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxClg.nativeElement).style.cursor = 'pointer';
  }

  mouseOutClg(e) {
    this.showWhiteClg = false;
    this.showNormalClg = true;
  }

  college() {
    this.isCollegeOpen = !this.isCollegeOpen;
  }

  mouseOverAdClg(e) {
    this.showWhiteAC = true;
    this.showNormalAC = false;
    (<HTMLDivElement>this.boxAdClg.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxAdClg.nativeElement).style.cursor = 'pointer';
  }

  mouseOutAdClg(e) {
    this.showWhiteAC = false;
    this.showNormalAC = true;
  }

  addcollege() {
    this.router.navigate(['/colleges']);
  }

  // === NEW: Order College hover handlers & navigation ===
  mouseOverOrderClg(e) {
    this.showWhiteOrderClg = true;
    this.showNormalOrderClg = false;
    if (this.boxOrderClg && this.boxOrderClg.nativeElement) {
      (<HTMLDivElement>this.boxOrderClg.nativeElement).style.pointerEvents =
        'auto';
      (<HTMLDivElement>this.boxOrderClg.nativeElement).style.cursor = 'pointer';
    }
  }

  mouseOutOrderClg(e) {
    this.showWhiteOrderClg = false;
    this.showNormalOrderClg = true;
  }

  mouseOverClgCourse(e) {
    this.showWhiteClgCourse = true;
    this.showNormalClgCourse = false;
    (<HTMLDivElement>this.boxClgCourse.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxClgCourse.nativeElement).style.cursor = 'pointer';
  }
  closeNav() {
    // remove toggled class on wrapper so content resizes
    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.classList.contains('toggled')) {
      wrapper.classList.remove('toggled');
    }

    // hide backdrop if you use one
    const backdrop = document.querySelector('.backdrop') as HTMLElement | null;
    if (backdrop) {
      backdrop.style.display = 'none';
    }

    // optional: ensure any internal boolean state is reset
    this.display = 'none';
  }

  mouseOutClgCourse(e) {
    this.showWhiteClgCourse = false;
    this.showNormalClgCourse = true;
  }

  addcoursecollege() {
    this.router.navigate(['/addcourseCollege']);
  }

  materials() {
    this.isMaterialOpen = !this.isMaterialOpen;
  }
  addmaterialcategory() {
    this.router.navigate(['/materials']);
  }
  addmaterialsubjects() {
    this.router.navigate(['/materialSubjects']);
  }
  addmaterialdocuments() {
    this.router.navigate(['/materialDocuments']);
  }

  Viewtopadmission() {
    this.router.navigate(['/topadmissionform']);
  }

  Viewmaterialyllsbus() {
    this.router.navigate(['/materialubsyllabus']);
  }

  ViewMaterialSub() {
    this.router.navigate(['/materialubscription']);
  }

  ViewMaterialPayment() {
    this.router.navigate(['/materialpayment']);
  }

  collegeDetails() {
    this.router.navigate(['/collegeDetails']);
  }
  videourl() {
    this.router.navigate(['/dashvideourl']);
  }

  showWhiteForeignCollegeFees = false;
  showNormalForeignCollegeFees = true;

  mouseOverForeignCollegeFees(event: any) {
    this.showWhiteForeignCollegeFees = true;
    this.showNormalForeignCollegeFees = false;
  }

  mouseOutForeignCollegeFees(event: any) {
    this.showWhiteForeignCollegeFees = false;
    this.showNormalForeignCollegeFees = true;
  }

  addForeignCollegeFees() {
    this.router.navigate(['/foreign-college-fees']);
  }
  mouseOverClgVideo(e) {
    this.showWhiteClgVideo = true;
    this.showNormalClgVideo = false;
    (<HTMLDivElement>this.boxClgVideo.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxClgVideo.nativeElement).style.cursor = 'pointer';
  }

  mouseOutClgVideo(e) {
    this.showWhiteClgVideo = false;
    this.showNormalClgVideo = true;
  }

  addVideos() {
    this.router.navigate(['/adVideo']);
  }

  mouseOverClgImage(e) {
    this.showWhiteClgImage = true;
    this.showNormalClgImage = false;
    (<HTMLDivElement>this.boxClgImage.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxClgImage.nativeElement).style.cursor = 'pointer';
  }

  mouseOutClgImage(e) {
    this.showWhiteClgImage = false;
    this.showNormalClgImage = true;
  }

  addClgImages() {
    this.router.navigate(['/addClgImgs']);
  }

  mouseOverCourse(e) {
    this.showWhiteCourse = true;
    this.showNormalCourse = false;
    (<HTMLDivElement>this.boxCourses.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxCourses.nativeElement).style.cursor = 'pointer';
  }

  mouseOutCourse(e) {
    this.showWhiteCourse = false;
    this.showNormalCourse = true;
  }

  courseDetails() {
    this.isOpen = !this.isOpen;
  }

  mouseOverAdCourse(e) {
    this.showWhiteAdCourse = true;
    this.showNormalAdCourse = false;
    (<HTMLDivElement>this.boxCourses.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxCourses.nativeElement).style.cursor = 'pointer';
  }

  mouseOutAdCourse(e) {
    this.showWhiteAdCourse = false;
    this.showNormalAdCourse = true;
  }

  courses() {
    this.router.navigate(['/cources']);
  }

  mouseOverDegreeType(e) {
    this.showWhiteDegreetype = true;
    this.showNormalDegreetype = false;
    (<HTMLDivElement>this.boxCourses.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxCourses.nativeElement).style.cursor = 'pointer';
  }

  mouseOutDegreeType(e) {
    this.showWhiteDegreetype = false;
    this.showNormalDegreetype = true;
  }

  degreeType() {
    this.router.navigate(['/degreeType']);
  }

  mouseOverCourseType(e) {
    this.showWhiteCoursetype = true;
    this.showNormalCoursetype = false;
    (<HTMLDivElement>this.boxCourses.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxCourses.nativeElement).style.cursor = 'pointer';
  }

  mouseOutCourseType(e) {
    this.showWhiteCoursetype = false;
    this.showNormalCoursetype = true;
  }

  courseType() {
    this.router.navigate(['/courseType']);
  }

  mouseOverDegree(e) {
    this.showWhiteDegree = true;
    this.showNormalDegree = false;
    (<HTMLDivElement>this.boxCourses.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxCourses.nativeElement).style.cursor = 'pointer';
  }

  mouseOutDegree(e) {
    this.showWhiteDegree = false;
    this.showNormalDegree = true;
  }

  degree() {
    this.router.navigate(['/addDegree']);
  }

  mouseOverCourseDetails(e) {
    this.showWhiteCourseDetails = true;
    this.showNormalCourseDetails = false;
    (<HTMLDivElement>this.boxCourses.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxCourses.nativeElement).style.cursor = 'pointer';
  }

  mouseOutCourseDetails(e) {
    this.showWhiteCourseDetails = false;
    this.showNormalCourseDetails = true;
  }

  addcourseDetails() {
    this.router.navigate(['/addCourseDetails']);
  }

  mouseOverScope(e) {
    this.showWhiteScope = true;
    this.showNormalScope = false;
    (<HTMLDivElement>this.boxScope.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxScope.nativeElement).style.cursor = 'pointer';
  }

  mouseOutScope(e) {
    this.showWhiteScope = false;
    this.showNormalScope = true;
  }

  scope() {
    this.router.navigate(['/scope']);
  }

  mouseOverCountry(e) {
    this.showWhiteCountry = true;
    this.showNormalCountry = false;
    (<HTMLDivElement>this.boxCountry.nativeElement).style.pointerEvents =
      'auto';
    (<HTMLDivElement>this.boxCountry.nativeElement).style.cursor = 'pointer';
  }

  mouseOutCountry(e) {
    this.showWhiteCountry = false;
    this.showNormalCountry = true;
  }

  addCountry() {
    this.router.navigate(['/addCountry']);
  }

  addDistrict() {
    this.router.navigate(['/addDistrict']);
  }

  addState() {
    this.router.navigate(['/addState']);
  }

  addTopColleges() {
    this.router.navigate(['/topColleges']);
  }

  addTrendingNews() {
    this.router.navigate(['/trendingNews']);
  }

  mouseOverAdimage(e) {
    this.showWhiteAdimage = true;
    this.showNormalAdimage = false;
    (<HTMLDivElement>this.boximage.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boximage.nativeElement).style.cursor = 'pointer';
  }

  mouseOutAdimage(e) {
    this.showWhiteAdimage = false;
    this.showNormalAdimage = true;
  }

  adImages() {
    this.router.navigate(['/adImages']);
  }

  mouseOveruser(e) {
    this.showWhiteuser = true;
    this.showNormaluser = false;
    (<HTMLDivElement>this.boxuser.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxuser.nativeElement).style.cursor = 'pointer';
  }

  mouseOutAduser(e) {
    this.showWhiteuser = false;
    this.showNormaluser = true;
  }

  userRole() {
    this.router.navigate(['/userRoles']);
  }

  mouseOveradmin(e) {
    this.showWhiteadmin = true;
    this.showNormaladmin = false;
    (<HTMLDivElement>this.boxadmin.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxadmin.nativeElement).style.cursor = 'pointer';
  }

  mouseOutadmin(e) {
    this.showWhiteadmin = false;
    this.showNormaladmin = true;
  }

  adminUpdate() {
    this.router.navigate(['/profile']);
  }

  payments() {
    this.router.navigate(['/payment']);
  }

  coursePayments() {
    this.router.navigate(['/coursepayment']);
  }

  mouseOverlogout(e) {
    this.showWhitelogout = true;
    this.showNormallogout = false;
    (<HTMLDivElement>this.boxlogout.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxlogout.nativeElement).style.cursor = 'pointer';
  }

  mouseOutlogout(e) {
    this.showWhitelogout = false;
    this.showNormallogout = true;
  }

  signout() {
    this.display = 'block';
  }

  studentsView() {
    this.router.navigate(['/users']);
  }

  /**
   * Close modal when click close button
   */
  onCloseHandled() {
    this.display = 'none';
  }
  /**
   * click ok to logout from the app
   */
  ok() {
    this.router.navigate(['/sign-in']);
  }

  hideMenu() {
    if (this.commonservice.screenWidth <= 910) {
      this.commonservice.showTour = { 'margin-left': '-250px' };
    } else {
      this.commonservice.showTour = { 'margin-left': '0px' };
    }
  }

  orderCollege() {
    this.router.navigate(['/order-college']);
  }
  foreignorderCollege() {
    this.router.navigate(['/foreignorder']);
  }
  notallow() {
    this.display = 'none';
  }

  showWhiteForeignCollegeImages = false;
  showNormalForeignCollegeImages = true;

  mouseOverForeignCollegeImages(event: any) {
    this.showWhiteForeignCollegeImages = true;
    this.showNormalForeignCollegeImages = false;
  }

  mouseOutForeignCollegeImages(event: any) {
    this.showWhiteForeignCollegeImages = false;
    this.showNormalForeignCollegeImages = true;
  }
  addForeignCollegeImages() {
    this.router.navigate(['/foreign-college-images']);
  }

  showWhiteForeignCollegeVideos = false;
  showNormalForeignCollegeVideos = true;

  addForeignCollegeVideos() {
    this.router.navigate(['/foreign-college-videos']);
  }

  mouseOverForeignCollegeVideos(event: any) {
    this.showWhiteForeignCollegeVideos = true;
    this.showNormalForeignCollegeVideos = false;
  }

  mouseOutForeignCollegeVideos(event: any) {
    this.showWhiteForeignCollegeVideos = false;
    this.showNormalForeignCollegeVideos = true;
  }

  // ===================== NEW helpers: set CSS var & emit event =====================
  /**
   * Set CSS variable (--sidebar-width) so your layout can use it (grid/margin)
   * openWidth/collapsedWidth should match your UI.
   */
  private setSidebarCssVar(open: boolean) {
    const openWidth = '280px';
    const collapsedWidth = '64px';
    document.documentElement.style.setProperty(
      '--sidebar-width',
      open ? openWidth : collapsedWidth
    );
  }

  /**
   * Dispatch a CustomEvent so other components can listen and respond.
   * detail: { open: boolean }
   */
  private emitSidebarToggled(open: boolean) {
    try {
      const ev = new CustomEvent('sidebarToggled', { detail: { open } });
      window.dispatchEvent(ev);
    } catch (e) {
      // old browser fallback
      const ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('sidebarToggled', true, true, { open });
      window.dispatchEvent(ev);
    }
  }
}
